<template>
  <Card v-if="weeks.length" title="Availability" margin="">
    <template #actions>
      <button class="btn btn-sm btn-outline-primary" @click="expanded = !expanded">
        {{ expanded ? __DICT__.hide : __DICT__.show }}
      </button>
    </template>
    <template #default>
      <div v-if="expanded" class="table-responsive">
        <table class="table table-vcenter card-table mb-0">
          <thead>
            <tr>
              <th style="width: 30%">{{ __DICT__.code }}</th>
              <th>{{ __DICT__.status }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="week in weeks" :key="week.code">
              <td class="fw-medium">{{ week.code }}</td>
              <td>
                <div
                  style="text-align: center;"
                  class="px-2 py-1 rounded center-text align-content-center fw-bold font-bold"
                  :class="statusBgClass(week.status)"
                >
                  {{ week.status || '—' }}
                </div>
                <div v-if="week.start || week.end" class="text-muted small mt-1 availability-points">
                  <span v-if="week.start">{{ __DICT__.season?.start || 'Start:' }} {{ week.start }}</span>
                  <span v-if="week.end">{{ __DICT__.season?.end || 'End:' }} {{ week.end }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </Card>
</template>

<script setup>
import { computed, ref } from 'vue'
import { Card } from "@/components/atomic";

// One shaped row from /api/mySeason/availability (Availability Matrix tab):
// { tenant, 'GBS ID', Rep, Brand, Role, weeks: [{ code, status, start, end }], ... }.
// The API discovers and orders the weeks; this component only renders them.
const props = defineProps({
  availabilityData: {
    type: Object,
    default: () => ({}),
  },
})

const expanded = ref(false) // default to collapsed

const weeks = computed(() => {
  const list = props.availabilityData?.weeks
  if (!Array.isArray(list)) return []
  return list
    .filter(w => w && typeof w === 'object' && w.code)
    .map(w => ({
      code: String(w.code),
      status: w.status == null ? '' : String(w.status),
      start: String(w.start ?? '').trim(),
      end: String(w.end ?? '').trim(),
    }))
})

// Week cell vocabulary (trimmed, case-insensitive): Available -> green,
// Not available / NA / N/A -> red, Allocated / Alloc -> blue, anything else
// (blank, a note, a status not seen yet) -> yellow.
function statusBgClass(val) {
  const v = (val || '').toString().trim().toLowerCase()
  if (v === 'available') return 'bg-green-lt text-green'
  if (v === 'na' || v === 'n/a' || v === 'not available') return 'bg-red-lt text-red'
  if (v === 'allocated' || v === 'alloc') return 'bg-blue-lt text-blue'
  return 'bg-yellow-lt text-yellow'
}
</script>

<style scoped>
.availability-points {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.25rem 0.75rem;
}
</style>
